/* eslint-disable */
import GLSL from './GLSL';
import fragmentShader from './reveal.frag';
import vertexShader from './reveal.vert';

export const reveal = (opts) => {
	const shaderConfig = {
		stageElement: opts.stageElement,
		sceneElement: opts.sceneElement,
		imageList: opts.imageList,
		onLoadStart: opts.onLoadStart,
		onLoadError: opts.onLoadError,
		onLoadProgress: opts.onLoadProgress,
		onLoadComplete: opts.onLoadComplete,
		debug: opts.debug,
		material: {
			fragmentShader,
			vertexShader,
			transparent: true,
			defines: {
				PI: Math.PI,
				DPR: window.devicePixelRatio.toFixed(1),
			},
			extensions: {
				derivatives: '#extension GL_OES_standard_derivatives : enable',
			},
			uniforms: (self, resolution) => ({
				u_time: { value: self.clock.getElapsedTime() },
				u_mobile: { type: 'b', value: opts.mobile },
				u_resolution: { type: 'v4', value: resolution },
				u_noiseWidth: { type: 'f', value: opts.noiseWidth, min: 0, max: 1 },
				u_smoothMask: { type: 'f', value: opts.smoothMask, min: 0, max: 1 },
				u_alpha: { type: 'f', value: 1, min: 0, max: 1 },
				u_texture1: { type: 't', value: self.textures[0] },
				u_texture2: { type: 't', value: self.textures[1] },
				u_progressHover: { value: opts.progress },
				u_progressClick: { value: 0 },
			}),
		},
	};
	return new GLSL(shaderConfig);
};

export default reveal;
